import React, { useState, useCallback, useRef, useEffect } from 'react';
import { MdOutlineQrCodeScanner } from "react-icons/md";
import {Scanner} from '@yudiel/react-qr-scanner'; // ✅ Fix: Default import
import { errorAlert } from '../lib/utils';

/**
 * A component to scan a QR code and parse the result.
 * #qrCode
 * It renders a button to open the scanner and then a scanner component
 * with a close button. When the QR code is scanned, it will call the
 * provided `saveCode` function with the parsed data.
 * 
 * The parsed data object will contain the following properties:
 * - year: The year as an integer (e.g., 2022)
 * - month: The month as an integer (e.g., 5)
 * - lotNumber: The lot number as a string
 * - serialNumber: The serial number as a string
 * - productNumber: The product number as a string
 * 
 * If the QR code is not in the expected format, it will show an error
 * alert.
 */
const ScanQrCode = ({ saveCode = () => {} }) => {
    const [showScanner, setShowScanner] = useState(false);
    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
            setShowScanner(false);
        };
    }, []);

    const handleScan = useCallback(async(result) => {
        await result
        if (result && mounted.current) {
            console.log("result:", result)
            const resultObj =  result?.[0]
            saveCode(result);
            setShowScanner(false);
/*             if (resultObj?.format === "qr_code" && resultObj.rawValue) {
                console.log("Raw QR value:", resultObj.rawValue);
                // Try to match the expected format (e.g., "BF270220000877822061-1")
                const match = resultObj.rawValue.match(/^([A-Z]{2}\d{3})(\d{2})(\d{2})(\d{5})(.*)/);
                
                if (match) {
                    console.log("Regex matches:", match);
                    const [_, lotNumber, year, month, fullSerialNumber, fullProductNumber] = match;
                    const serialNumber = fullSerialNumber.replace(/^0+/, ''); // Remove leading zeros
                    const productNumber = fullProductNumber.slice(3); // Remove first 3 digits
                    const parsedData = {
                        year: 2000 + parseInt(year), // Convert "22" to 2022
                        month: 5, // Hardcoded to 5 as per requirements
                        lotNumber,
                        serialNumber, // Keep as string
                        productNumber
                    };
                    console.log("Translated Doc", parsedData)
                    saveCode(parsedData);
                    setShowScanner(false);
                } else {
                    errorAlert("IL FORMATO DEL CODICE QR NON E' STATO RICONOSCIUTO");
                    setShowScanner(false);
                }
            } else {
                errorAlert("IL FORMATO DEL CODICE QR NON E' STATO RICONOSCIUTO");
                setShowScanner(false);
            } */
        }
    }, [saveCode]);

    const handleError = useCallback((error) => {
        if (mounted.current) {
            console.error(error);
        }
    }, []);

    if (!showScanner) {
        return (
            <div onClick={() => setShowScanner(true)}>
                <MdOutlineQrCodeScanner size={45} />
            </div>
        );
    }

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', zIndex: 1000 }}>
            <div style={{ position: 'relative', maxWidth: '600px', margin: '40px auto' }}>
                <button 
                    onClick={() => setShowScanner(false)}
                    style={{
                        position: 'absolute',
                        top: '-30px',
                        right: '10px',
                        background: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        cursor: 'pointer'
                    }}
                >
                    ✕
                </button>
                <Scanner
                    onResult={()=>console.log("finished")} // ✅ Changed from onFound to onResult
                    //onFound={handleScan}
                    onScan={handleScan}
                    onError={handleError}
                />
            </div>
        </div>
    );
};

export default ScanQrCode;
